import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculators-smartgeyser.component.scss';
var CalculatorsSmartgeyser = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorsSmartgeyser, _super);
    function CalculatorsSmartgeyser(element) {
        return _super.call(this, element) || this;
    }
    CalculatorsSmartgeyser.prototype.init = function () {
        this.form = this.element.querySelector("form");
        var monthlyServiceFeeInputs = Array.from(document.querySelectorAll("input[name=monthlyServiceFee]"));
        monthlyServiceFeeInputs.forEach(function (element) {
            element.setAttribute("readOnly", "true");
        });
    };
    CalculatorsSmartgeyser.prototype.bindEvents = function () {
        var _this = this;
        var calcButtons = Array.from(document.querySelectorAll("a.js-calculator-geyser-calculate"));
        calcButtons.map(function (element) {
            element.addEventListener("click", function (pEvent) {
                _this.detect(element.closest("form"));
            });
        });
        var resetButtons = Array.from(document.querySelectorAll(".js-calculator-smartgeyser-reset"));
        resetButtons.map(function (element) {
            element.addEventListener("click", function (pEvent) {
                _this.resetValues(element.closest("form"));
            });
        });
    };
    CalculatorsSmartgeyser.prototype.detect = function (calcform) {
        switch (calcform.id) {
            case 'calculators-smartgeyser_save_amount':
                this.doCalcSmartGeyserSave(calcform);
                break;
            case 'calculators-smartgeyser_save_units':
                this.doCalcSmartGeyserUnits(calcform);
                break;
        }
    };
    CalculatorsSmartgeyser.prototype.doCalcSmartGeyserSave = function (form) {
        var monthlyElectricPayment = form.querySelector('input[name=monthlyElectricPayment]');
        var returnValue = this.DO_CALC_GYSER_SAVE(parseFloat(monthlyElectricPayment.value));
        var amountSavedNoServiceFeeElmt = document.querySelectorAll('span.js-calculator-smartgeyser-save-span');
        [].slice.call(amountSavedNoServiceFeeElmt).forEach(function (div) {
            div.innerHTML = returnValue;
        });
    };
    CalculatorsSmartgeyser.prototype.DO_CALC_GYSER_SAVE = function (monthlyElectricPayment) {
        var amountSaved = monthlyElectricPayment * 0.35 * 0.35;
        if ((amountSaved - Math.round(amountSaved)) === 0) {
            return amountSaved;
        }
        return this.formatter(amountSaved);
    };
    CalculatorsSmartgeyser.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorsSmartgeyser.prototype.resetValues = function (form) {
        var inputs = Array.from(document.querySelectorAll("input"));
        inputs.forEach(function (element) {
            if (element.name !== 'monthlyServiceFee') {
                element.value = '0';
            }
        });
        var saveMinServiceSmartGeyser = document.querySelectorAll('span.js-calculator-smartgeyser-save-minservice-span');
        var savePlusServiceSmartGeyser = document.querySelectorAll('span.js-calculator-smartgeyser-save-span');
        [].slice.call(saveMinServiceSmartGeyser).forEach(function (div) {
            div.innerHTML = '0';
        });
        [].slice.call(savePlusServiceSmartGeyser).forEach(function (div) {
            div.innerHTML = '0';
        });
    };
    return CalculatorsSmartgeyser;
}(Base));
export { CalculatorsSmartgeyser };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-smartgeyser/calculators-smartgeyser.component.ts
// module id = 795
// module chunks = 0